import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_global/elements/tckt/AnimatedTicketLogo.jsx");
